import { Button, Col, DatePicker, Input, Modal, Row, TimePicker } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { getAttendanceProfileTabs, markAttendance, setLoader, setMarkAttendance, selectedAttendance, usersDownloadReport, storeSelectedRange, storeStartDate, storeEndDate, getAttendanceDashBoardData, attendanceRequirementDetail } from 'actions/attendanceNew'
import { ConsoleSqlOutlined } from '@ant-design/icons'
import { getAttendanceRequests } from 'actions/profileNew'
import { Notification } from 'services'

// const istrue=true
const RequestAttendanceModel = ({ isModalVisible, setIsModalVisible, setMarkAttendance, markAttendance, setLoader, loaders, user, disabledDate, markAttendanceObj, fromWhere, getAttendanceProfileTabs,getAttendanceDashBoardData, getattendanceRequirement, attendanceRequests, getAttendanceRequests, getAttendanceSetting }) => {

    const [diffT, setDiff] = useState(0)

    const handleOk = () => {
        setIsModalVisible(false);
        
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setMarkAttendance('startDate', '')

    };

    const handleRequest = () => {
        // Enforce limit check for regular users (not SuperAdmin)
        if (!user?.privilage?.includes("SuperAdmin")) {
            const role = user?.role;
            const roleStr = Array.isArray(role) ? role[0] : role;
            
            let limit = null;
            if (getattendanceRequirement) {
                if (roleStr === 'Teacher') {
                    limit = getattendanceRequirement.requestCountTeacher;
                } else if (roleStr === 'Data Operator') {
                    limit = getattendanceRequirement.requestCountDO;
                } else if (roleStr === 'Operation') {
                    limit = getattendanceRequirement.requestCountOperation;
                } else if (roleStr === 'Student') {
                    limit = getattendanceRequirement.requestCountStudent;
                }
            }

            if (limit !== null && limit !== undefined && !isNaN(parseInt(limit, 10))) {
                const parsedLimit = parseInt(limit, 10);
                const selectedMonthStr = moment(markAttendanceObj?.startDate).format("YYYY-MM");
                const manualPunchesThisMonth = (attendanceRequests?.items || []).filter(item => {
                    const isAttendance = item.requestType?.toUpperCase() === "ATTENDANCE";
                    const isApprovedOrPending = item.status?.toUpperCase() === "APPROVED" || item.status?.toUpperCase() === "PENDING";
                    const matchesMonth = item.startDate && moment(item.startDate).format("YYYY-MM") === selectedMonthStr;
                    return isAttendance && isApprovedOrPending && matchesMonth;
                });
                const currentCount = manualPunchesThisMonth.length;
                if (currentCount >= parsedLimit) {
                    Notification.error("Error", "Manual punch limit for this month has been exceeded");
                    return;
                }
            }
        }

        if(fromWhere == 'Profile'){
            markAttendance(() => { setIsModalVisible(false)}, () => {getAttendanceProfileTabs(),getAttendanceDashBoardData(() => {})})
        } else{
            markAttendance(() => { setIsModalVisible(false)}, () => {getAttendanceDashBoardData(() => {})})
        }
    
    }

    useEffect(() => {
        setLoader('modalClockLoader', false)
        setMarkAttendance('requestType', 'Attendance')
    }, [])

    useEffect(() => {
        if (isModalVisible) {
            if (getAttendanceSetting) getAttendanceSetting();
            if (getAttendanceRequests && user?.id) {
                getAttendanceRequests({ userId: user?.id, page: 1, limit: 100 }, () => {});
            }
        }
    }, [isModalVisible])
    
    const calcDiff = () => {
        console.log('total')
        let clockIn = moment(markAttendanceObj?.clockIn, 'HH:mm a');
        let clockOut = moment(markAttendanceObj?.clockOut, 'HH:mm a');
        let totalHours = clockOut.diff(clockIn, 'minutes')
        let a = totalHours;
        if (a===a) {
            console.log("total hours2", totalHours);
            totalHours = parseFloat(totalHours/60).toFixed(2);
            setMarkAttendance('totalhours',totalHours)
            setDiff(totalHours)
        }

    }

    useEffect(() => {
        calcDiff()
    }, [markAttendanceObj?.clockIn, markAttendanceObj?.clockOut])

    function disabledDate(current) {
        return current && (current < moment().add(-4, "days") || current > moment().add(-1, "days"))
    }

    const timerDisable = (dependency) => {
        for (let x of dependency){
          let bool = markAttendanceObj[x] === ''||markAttendanceObj[x]==='Invalid date'||markAttendanceObj[x]==undefined
          if (bool) return true
        }
        return false
      }

    const disabledStartTimeHours = () => {

        const hours = []
        if (moment().format('YYYY-MM-DD') === markAttendanceObj?.startDate) {
            for (var i = 25; i > moment().hour(); i--) {
                hours.push(i)
            }
        }
        return hours
    }

    const disabledStartTimeMinutes = (selectedHour) => {
        // console.log('first', selectedHour)
        var minutes = []
        if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === markAttendanceObj?.startDate) {
            for (var i = 60; i >= moment().minute(); i--) {
                minutes.push(i);
            }
        }
        return minutes;
    }

    const disabledEndTimeHours = () => {

        var hours = []
        for (var i = 0; i < moment(markAttendanceObj?.clockIn, 'HH:mm:ss').hour(); i++) {
            hours.push(i)
        }

        if (moment().format('YYYY-MM-DD') === markAttendanceObj?.startDate) {
            for (var i = 25; i > moment().hour(); i--) {
                hours.push(i)
            }
        }
        return hours
    }

    const disabledEndTimeMinutes = (selectedHour) => {
        var minutes = []
        if (selectedHour === moment(markAttendanceObj?.startDate, 'HH:mm:ss').hour()){
            for (var i = 0; i <= moment(markAttendanceObj?.startDate, 'HH:mm:ss').minute(); i++) {
                minutes.push(i);
            }
        }

        if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === markAttendanceObj?.startDate) {
            for (var i = 60; i > moment().minute(); i--) {
                minutes.push(i);
            }
        }
        return minutes;
    }


    useEffect(() => {
        setMarkAttendance('startDate', null)
        setMarkAttendance('clockIn', null)
        setMarkAttendance('clockOut', null)
        setMarkAttendance('reason', null)
        setMarkAttendance('totalhours', null)
        setDiff('')

    }, [])
   

    return (
        <>
            <Modal
                centered
                className="modal-round-corner"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                header={null}
                footer={null}>
                <Row>
                    <div className='font' style={{ color: "#191919", fontSize: "22px", marginLeft: "150px" }}>
                        {(user?.privilage?.includes("SuperAdmin")) ? "Mark Attendance" : "Request Attendance"}
                    </div>
                </Row>

                <Row>
                    <Col className='m-t-10 m-l-10'>
                        <div className='font' style={{ fontSize: "12px", color: "#636363" }}>Date <span style={{ color: "red" }}>*</span></div>
                       { console.log("aaaa",markAttendanceObj?.startDate)}
                        <div><DatePicker
                        // value={moment(markAttendanceObj?.startDate,'YYYY-MM-DD').format('YYYY-MM-DD')}
                        // value={moment(markAttendanceObj?.startDate,'YYYY-MM-DD')}
                        // value={moment(markAttendanceObj?.startDate,'YYYY-MM-DD')}
                        // value={markAttendanceObj?.startDate}
                        value={!markAttendanceObj?.startDate  ?'' : moment(markAttendanceObj?.startDate) }


// 


                           
                            allowClear={false}
                            onKeyDown={(e)=>{e.preventDefault()}}
                            disabledDate={disabledDate}
                            style={{ width: "460px" }}
                            onChange={(date,dateString) => setMarkAttendance('startDate', dateString)}
                        /></div>
                    </Col>
                </Row>
                <Row>
                    <Col className='flex-row'>
                        <Col className='m-t-10 m-l-10' style={{ width: "50%" }}>
                            <div className='font' style={{ fontSize: "12px", color: "#636363" }}>Clock in <span style={{ color: "red" }}>*</span></div>
                            <div>
                                {console.log("AAA",markAttendanceObj?.clockIn )}
                                <TimePicker
                                allowClear={false}
                                value={!markAttendanceObj?.clockIn  ?'' : moment(markAttendanceObj?.clockIn ,'h:mm') }
                                onKeyDown={(e)=>{e.preventDefault()}}
                                disabled={timerDisable(['startDate'])}
                                disabledHours={()=>disabledStartTimeHours()}
                                disabledMinutes={disabledStartTimeMinutes}
                                format={'HH:mm'}
                                style={{ width: "225px" }}
                                onChange={(e, time) => {
                                    console.log("AAA-time",time);
                                    setMarkAttendance('clockIn', moment(time, 'HH:mm').format('HH:mm'));
                                }}
                            />
                            </div>
                        </Col>
                        <Col className='m-t-10 m-l-10' style={{ width: "50%" }}>
                            <div className='font' style={{ fontSize: "12px", color: "#636363" }}>Clock out <span style={{ color: "red" }}>*</span></div>
                            <div><TimePicker
                                allowClear={false}
                                value={!markAttendanceObj?.clockOut  ? '' : moment(markAttendanceObj?.clockOut,'h:mm') }
                                onKeyDown={(e)=>{e.preventDefault()}}
                                disabled={timerDisable(['startDate', 'clockIn'])}
                                disabledHours={()=>disabledEndTimeHours()}
                                disabledMinutes={disabledEndTimeMinutes}
                                format={'HH:mm'}
                                style={{ width: "225px" }}
                                onChange={(e, time) => {
                                    setMarkAttendance('clockOut', moment(time, 'HH:mm:ss').format('HH:mm:ss'));
                                }}
                            />
                            </div>
                        </Col>
                    </Col>
                </Row>

                <Row>
                    <div className='m-t-10 m-l-10'>
                        <div className='font' style={{ fontSize: "12px", color: "#636363" }}>Total hours</div>
                                {console.log("AA-diffT",diffT)}
                        <Input
                            disabled={true}
                            readOnly={true}
                            placeholder='Total hours' 
                            style={{ 
                                width: "460px", 
                                backgroundColor: "#FAFAFA", 
                                color: "#AEAEAE", 
                                cursor: "not-allowed" 
                            }}
                            onChange={(e) => {
                                setMarkAttendance('totalhours', e.target.value);
                            }}
                            value={(!markAttendanceObj?.clockOut  ? ''  : (isNaN(diffT) ? 0 : diffT > 0 ? diffT : 0))}
                            // value={!markAttendanceObj?.clockOut  ? '' : moment(markAttendanceObj?.clockOut,'h:mm')}
                        >
                        </Input>
                    </div>
                </Row>

                <Row>
                    <div className='m-t-10 m-l-10'>
                        <div className='font' style={{ fontSize: "12px", color: "#636363" }}>Reason(s) <span style={{ color: "red" }}>*</span></div>
                        <Input placeholder='Enter reason(s)' style={{ width: "460px", height: "70px" }} 
                        value={!markAttendanceObj?.reason ? '' :  markAttendanceObj?.reason}
                        onChange={(e) => setMarkAttendance('reason', e.target.value)}></Input>
                    </div>
                </Row>

                <Row style={{ marginLeft: "120px" }}>
                    <Col className='p-5'>
                        <Button className='m-t-20'
                            style={{
                                borderRadius: "19px",
                                width: "110px",
                                height: "35px",
                                fontWeight: "500",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #636363 ",
                                color: "#636363",
                            }} onClick={handleCancel}
                        >CANCEL
                        </Button>
                    </Col>
                    {console.log("AA-diffT",diffT)}
                    <Col className='p-5'>
                        <Button className='m-t-20'
                            style={{
                                borderRadius: "19px",
                                width: "110px",
                                height: "35px",
                                fontWeight: "500",
                                backgroundColor: "#594099",
                                border: "1px solid #636363 ",
                                color: "#FFFFFF",
                                opacity: markAttendanceObj?.reason === '' && markAttendanceObj?.totalHours === '' && markAttendanceObj?.startDate === '' ? 0.5 : 1,
                            }}
                            disabled={diffT != 0.00 && markAttendanceObj?.clockOut != 'Invalid date' &&markAttendanceObj?.clockIn != 'Invalid date' && markAttendanceObj?.reason?.length > 0 ? false : true}
                            loading={loaders?.modalClockLoader}
                            onClick={() => { handleRequest() }}
                        > {user?.privilage?.includes("SuperAdmin") ? 'Mark' : 'Request'}
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    const { AttendanceTab, storeselectedAttendance, loaders, startDateContainer, selectedRangeContainer, markAttendanceObj, getattendanceRequirement } = state.attendanceNew;
    const { user } = state.session;
    const { attendanceRequests } = state.profileNew;
    return { AttendanceTab, user, storeselectedAttendance, loaders, startDateContainer, selectedRangeContainer, markAttendanceObj, getattendanceRequirement, attendanceRequests };
};

const mapDispatchToProps = (dispatch) => ({
    getAttendanceProfileTabs: () => (dispatch(getAttendanceProfileTabs())),
    selectedAttendance: (val) => (dispatch(selectedAttendance(val))),
    setMarkAttendance: (key, val) => dispatch(setMarkAttendance(key, val)),
    markAttendance: (callBack,successCallBack) => dispatch(markAttendance(callBack,successCallBack)),
    setLoader: (key, val) => dispatch(setLoader(key, val)),
    usersDownloadReport: (callback, successCallBack) => (dispatch(usersDownloadReport(callback, successCallBack))),
    storeSelectedRange: (val) => dispatch(storeSelectedRange(val)),
    storeStartDate: (val) => dispatch(storeStartDate(val)),
    storeEndDate: (val) => dispatch(storeEndDate(val)),
    getAttendanceDashBoardData: callback => dispatch(getAttendanceDashBoardData(callback)),
    getAttendanceRequests: (params, callback) => dispatch(getAttendanceRequests(params, callback)),
    getAttendanceSetting: () => dispatch(attendanceRequirementDetail()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestAttendanceModel)

